(() => {
  if (window.__snugMobileMenuFixLoaded) return;
  window.__snugMobileMenuFixLoaded = true;

  const OPEN_CLASS = 'nav-open';
  const getToggle = (target) => target && target.closest ? target.closest('[data-action="toggle-nav"]') : null;
  const getClose = (target) => target && target.closest ? target.closest('close-menu, .close-menu') : null;
  const getNavigation = () => document.querySelector('.navigation');
  const getToggleButton = () => document.querySelector('[data-action="toggle-nav"]');

  const setExpanded = (expanded) => {
    const toggle = getToggleButton();
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const openMenu = () => {
    const navigation = getNavigation();
    if (!navigation) return;
    document.body.classList.add(OPEN_CLASS);
    document.documentElement.classList.add('mobile-menu-open');
    setExpanded(true);
  };

  const closeMenu = () => {
    document.body.classList.remove(OPEN_CLASS);
    document.documentElement.classList.remove('mobile-menu-open');
    setExpanded(false);
  };

  document.addEventListener('click', (event) => {
    const toggle = getToggle(event.target);
    if (toggle) {
      window.setTimeout(() => {
        if (!document.body.classList.contains(OPEN_CLASS)) openMenu();
        else setExpanded(true);
      }, 40);
      return;
    }

    if (getClose(event.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
      closeMenu();
      const toggle = getToggleButton();
      if (toggle) toggle.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1025 && document.body.classList.contains(OPEN_CLASS)) {
      closeMenu();
    }
  }, { passive: true });
})();
